import { Link } from '@tanstack/react-router';
import { Button } from '../ui/button';
import { DataNotFoundSection } from './DataNotFoundSection';
import { UsersRound, MoveUpRight } from 'lucide-react';
import { Badge } from '../ui/badge';
import LeaderboardCardSkeleton from '../skeletons/LeaderboardCardSkeleton';

const OverallXpRankSection = ({ isLoading, leaderboard, user, currentUserRank, isUserInTopFive }) => {
    return (
        <div className="border border-neutral-300 rounded-lg">
            <div className="pt-4 px-4 pb-2">
                <h4 className="mb-1 capitalize">Overall XP Rank</h4>
                <p className="capitalize">Complete learning actions to gain XP</p>
            </div>
            <div className=" flex flex-col bg-neutral-50 rounded-lg mt-4">
                {isLoading ? (
                    <LeaderboardCardSkeleton />
                ) : (
                    <>
                        {leaderboard.slice(0, 5).map((player, index) => (
                            <div
                                key={`${player.id}-${player.course ?? ''}-${index}`}
                                className={`flex justify-between items-center ${
                                    index === 0 ? 'border-y' : 'border-b'
                                } border-neutral-300 p-5 ${player.id === user?.id ? 'bg-neutral-100 text-neutral-950' : ''}`}
                            >
                                <span className="flex flex-wrap gap-2 justify-start items-center ">
                                    <p className={`${player.id === user?.id ? 'text-neutral-950' : 'text-neutral-700'}`}>
                                        {String(player.rank).padStart(2, '0')}
                                    </p>
                                    <p
                                        className={`capitalize ${
                                            player.id === user?.id ? 'text-neutral-950' : 'text-neutral-700'
                                        }`}
                                    >
                                        {player.name}
                                    </p>
                                    {player.id === user?.id && (
                                        <Badge variant="destructive" className="py-0.5 px-2 bg-success">
                                            You
                                        </Badge>
                                    )}
                                </span>
                                <span className={`${player.id === user?.id ? 'text-neutral-950' : 'text-neutral-700'}`}>
                                    {player.points?.toLocaleString() || 0} XP
                                </span>
                            </div>
                        ))}
                        {currentUserRank && !isUserInTopFive && leaderboard.length > 5 && (
                            <>
                                <div
                                    key={`${currentUserRank.id}-${currentUserRank.course ?? ''}-${currentUserRank.rank}`}
                                    className="flex justify-between items-center border-b border-neutral-300 p-5 bg-neutral-100 text-neutral-950"
                                >
                                    <span className="flex flex-wrap gap-2 justify-start items-center">
                                        <p>{String(currentUserRank.rank).padStart(2, '0')}</p>
                                        <p className="capitalize">{currentUserRank.name}</p>
                                        <Badge variant="destructive" className="py-0.5 px-2 bg-success">
                                            You
                                        </Badge>
                                    </span>
                                    <span>{currentUserRank.points?.toLocaleString() || 0} XP</span>
                                </div>
                            </>
                        )}
                        {leaderboard.length === 0 && !isLoading && (
                            <div className="flex flex-col justify-center items-center my-3 h-75 bg-neutral-100">
                                <DataNotFoundSection
                                    title={'No ranking data available.'}
                                    dashboard={true}
                                    icon={<UsersRound size={30} className="text-primary mb-4 w-12 h-12" />}
                                />
                            </div>
                        )}
                    </>
                )}

                <div className="mb-2">
                    <Link to="/leaderboard" preload="intent" preloadDelay={0}>
                        <Button
                            variant="link"
                            className="w-full font-semibold flex items-center justify-center gap-2 mt-1 rounded-none rounded-b-lg"
                        >
                            <span>View Leaderboards</span>
                            <MoveUpRight size={20} />
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default OverallXpRankSection;
